export default __webpack_public_path__ + "static/media/366065__simone-ds__chess-pieces.4e2a12c8.mp3";